import { render, staticRenderFns } from "./WorkView.vue?vue&type=template&id=4927b798&scoped=true&"
import script from "./WorkView.vue?vue&type=script&lang=js&"
export * from "./WorkView.vue?vue&type=script&lang=js&"
import style0 from "./WorkView.vue?vue&type=style&index=0&id=4927b798&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4927b798",
  null
  
)

export default component.exports